import React, { useEffect, useState } from "react";
import {
  BoxContainer,
  BoxHead,
  BoxTitle,
  Underline,
} from "../../Components/Styles/PageStyles";
import ProductReport from "../../Components/Reports/Report";
import Table from "../../Components/Reports/Table";
import tw from "tailwind-styled-components";
import NotFoundModel from "../../Components/NotFoundModel";
import { useMutation } from "react-query";
import axios from "axios";
import { useSelector } from "react-redux";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import { useLocation } from "react-router-dom";
import SideModal from "../../Components/SideModal";
import ScheduleReport from "./ScheduleReport";

const Reports = () => {
  const location = useLocation();
  const [filterType, setFilterType] = useState(
    () => location.state?.activeTab || "1"
  );
  const [apiData, setApiData] = useState();
  const [filteredApiData, setFilteredApiData] = useState();
  const [tenantAttendanceEnabled, setTenantAttendanceEnabled] = useState();
  const [showScheduleReport, setShowScheduleReport] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [isScheduleLoading, setIsScheduleLoading] = useState(false);
  const user = useSelector((state) => state.UserReducer.user);
  const isSalesHead = user.role === Config.STAFF_ROLES.SALES_HEAD;

  // ---------- existing report list ----------
  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/report/list`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) return;
    setApiData(res?.reportList);
    setTenantAttendanceEnabled(res?.tenantAttendanceEnabled);
    if (isSalesHead) {
      setFilteredApiData(
        res?.reportList?.filter((r) => [8, 11, 12].includes(r.reportType))
      );
    } else {
      setFilteredApiData(res?.reportList);
    }
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: () => {},
  });

  useEffect(() => {
    const handler = setTimeout(() => getListMutate(), 500);
    return () => clearTimeout(handler);
  }, []);

  // ---------- schedule list ----------
  const fetchScheduleList = async () => {
    const response = await axios.get(`${Config.apiUrl}/report/schedule/list`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const {
    isLoading: isScheduleListLoading,
    mutate: getScheduleListMutate,
  } = useMutation(fetchScheduleList, {
    onSuccess: (res) => {
      if (res?.isSuccess === false) {
        setSchedules([]);
      } else {
        // API may return `scheduleList` or `reportScheduleList` — adjust to actual key
        setSchedules(res?.data ||[]);
      }
      setShowScheduleReport(true);
    },
    onError: () => {
      setSchedules([]);
      setShowScheduleReport(true);
    },
  });

  const handleOpenSchedule = () => {
    setShowScheduleReport (true);
    // setIsScheduleLoading(true);
    // getScheduleListMutate(undefined, {
    //   onSettled: () => setIsScheduleLoading(false),
    // });
  };

  const refetchSchedules = () => {
    getScheduleListMutate(undefined, {
      onSuccess: (res) => {
        if (res?.isSuccess !== false) {
          setSchedules(res?.data || []);
        }
      },
    });
  };

  return (
    <BoxContainer className="!h-auto">
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Reports
          <Underline />
        </BoxTitle>
        <div className="flex space-x-4 md:ml-auto">
          <AddBtn
            type="button"
            onClick={handleOpenSchedule}
            disabled={isScheduleListLoading || isScheduleLoading}
          >
            {isScheduleListLoading || isScheduleLoading
              ? "Loading..."
              : "Schedule Report"}
          </AddBtn>
        </div>
      </BoxHead>

      <SideModal
        isOpen={showScheduleReport}
        onClose={() => setShowScheduleReport(false)}
        level="base"
      >
        <ScheduleReport
          handleClose={() => setShowScheduleReport(false)}
          showScheduleReport={showScheduleReport}
          setShowScheduleReport={setShowScheduleReport}
          schedules={schedules}
          refetchSchedules={refetchSchedules}
          tenantAttendanceEnabled={tenantAttendanceEnabled}
        />
      </SideModal>

      {!error && !isLoading && data && (
        <>
          <ButtonGroup>
            <TemplateButton
              isActive={filterType === "1"}
              onClick={() => setFilterType("1")}
            >
              Category
            </TemplateButton>
            <TemplateButton
              ml
              isActive={filterType === "2"}
              onClick={() => setFilterType("2")}
            >
              Downloads
            </TemplateButton>
          </ButtonGroup>
          <Seperator />
          {filterType === "1" ? (
            <ProductReport tenantAttendanceEnabled={tenantAttendanceEnabled} />
          ) : (
            <TableWrapper>
              <Table apiData={error ? [] : filteredApiData} />
              {(!filteredApiData || filteredApiData.length === 0) &&
                !isLoading && <NotFoundModel />}
            </TableWrapper>
          )}
        </>
      )}
      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const ButtonGroup = tw.div`flex items-center !gap-0`;
const TemplateButton = tw.button`
  px-2 font-semibold relative ${(props) =>
    props.isActive ? "text-primary-color" : "text-gray-600"}
  ${(props) => (props.ml ? "ml-2" : "")}
  after:absolute after:top-8 after:left-0 after:w-full after:h-0.5
  ${(props) => (props.isActive ? "after:bg-blue-500" : "")}
`;
const Seperator = tw.div`w-full h-[0.090rem] bg-gray-200 mt-2 `;
const TableWrapper = tw.h1`mt-8 border bg-white rounded-md`;
const AddBtn = tw.button`whitespace-nowrap flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm disabled:opacity-60`;

export default Reports;